import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from 'swiper';
import 'swiper/swiper-bundle.css';
var default_1 = /** @class */ (function () {
    function default_1() {
        this.slideshow();
    }
    default_1.prototype.slideshow = function () {
        Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);
        var thumbnailElm = document.querySelectorAll('.thumbSlider .swiper-slide');
        var sliderThumbnail = new Swiper(".thumbSlider", {
            slidesPerView: thumbnailElm.length,
            width: Number(68 * thumbnailElm.length),
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    width: Number(128 * thumbnailElm.length),
                    spaceBetween: 24,
                },
                1680: {
                    width: Number(158 * thumbnailElm.length),
                    spaceBetween: 32,
                },
                1920: {
                    width: Number(180 * thumbnailElm.length),
                    spaceBetween: 32,
                },
            }
        });
        var mySwiper = new Swiper('.mainSlider', {
            loop: true,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
            },
            height: 604,
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    height: null
                }
            },
            thumbs: {
                swiper: sliderThumbnail,
            },
        });
        var featureSwiper = new Swiper('.featureSlider', {
            loop: true,
            loopAdditionalSlides: 1,
            autoplay: {
                delay: 3500,
                disableOnInteraction: true,
            },
            height: 211,
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    height: 254,
                    spaceBetween: 16,
                    loopAdditionalSlides: 4,
                }
            },
            pagination: {
                el: ".slider-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
            },
        });
    };
    return default_1;
}());
export default default_1;
